module.exports = __webpack_public_path__ + "media/components/t-shirt-comp/static/Salinas-88f247fdae0f0f3c4318bac42b5a3ee7.jpg";